import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoadingData: false,
  isLoading: false,
  calendar: null,
  message: null,
  selectedPatientSurgery: null,
};

const resetState = (state, keys) => {
  keys.forEach((key) => {
    state[key] = initialState[key];
  });
};

export const calendarSlice = createSlice({
  name: "valuationCalendar",
  initialState,
  reducers: {
    onLoadingCalendar: (state) => {
      state.isLoadingData = true;
      state.message = null;
    },
    onLoading: (state) => {
      state.isLoading = true;
      state.message = null;
    },
    onLoaded: (state) => {
      state.isLoading = false;
      state.message = null;
    },
    onLoadCalendar: (state, { payload }) => {
      state.isLoadingData = false;
      state.message = null;
      state.calendar = payload;
    },
    onFailedCalendar: (state, { payload }) => {
      state.isLoadingData = false;
      state.message = {
        type: "errorCalendar",
        text: payload,
      };
      resetState(state, ["calendar"]);
    },
    onErrorMessage: (state, { payload }) => {
      state.isLoading = false;
      state.message = {
        type: "error",
        text: payload,
      };
    },
    onErrorSelect: (state, { payload }) => {
      state.isLoading = false;
      state.message = {
        type: "errorSelect",
        text: payload,
      };
    },
    onSuccessMessage: (state, { payload }) => {
      state.isLoading = false;
      state.message = {
        type: "success",
        text: payload,
      };
    },
    onCleanCalendar: (state, { payload }) => {
      state.calendar = null;
    },
    onAddCalendareEvent: (state, { payload }) => {
      state.calendar.eventSchedules.push(payload);
    },
    onUpdateCalendarEvent: (state, { payload }) => {
      const index = state.calendar.eventSchedules.findIndex(
        (scheduleEvent) => scheduleEvent.id === payload.id
      );
      if (index !== -1) {
        state.calendar.eventSchedules[index] = {
          ...state.calendar.eventSchedules[index],
          ...payload,
        };
      }
    },
    onUpdatePatientSurgeryByAssessmentMade: (state, { payload }) => {
      const { scheduleEvent, patientSurgery } = payload;

      const index = state.calendar.eventSchedules.findIndex(
        (eventSchedule) => eventSchedule.id === scheduleEvent.id
      );

      if (index !== -1) {
        state.calendar.eventSchedules = state.calendar.eventSchedules.map(
          (beforeScheduleEvent, i) =>
            i === index
              ? {
                  ...beforeScheduleEvent,
                  ...scheduleEvent,
                  patientSurgery: {
                    ...beforeScheduleEvent.patientSurgery,
                    ...patientSurgery,
                  },
                }
              : beforeScheduleEvent
        );
      }
    },
    onUpdatePatientSurgeryByNoPresentAssessment: (state, { payload }) => {
      const { scheduleEvent } = payload;

      const index = state.calendar.eventSchedules.findIndex(
        (scheduleEvent) => scheduleEvent.id === scheduleEvent.id
      );
      if (index !== -1) {
        state.calendar.eventSchedules = state.calendar.eventSchedules.map(
          (beforeScheduleEvent, i) =>
            i === index
              ? {
                  ...beforeScheduleEvent,
                  ...scheduleEvent,
                }
              : beforeScheduleEvent
        );
      }
    },
    setSelectedPatientSurgery: (state, { payload }) => {
      state.selectedPatientSurgery = payload;
    },
    resetSelectedPatientSurgery: (state) => {
      state.selectedPatientSurgery = null;
    },
    updateSelectedPatientSurgery: (state, { payload }) => {
      state.selectedPatientSurgery = {
        ...state.selectedPatientSurgery,
        ...payload,
      };
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  onLoadingCalendar,
  onLoading,
  onLoaded,
  onLoadCalendar,
  onFailedCalendar,
  onErrorMessage,
  onErrorSelect,
  onSuccessMessage,
  onCleanCalendar,
  onAddCalendareEvent,
  onUpdateCalendarEvent,
  onUpdatePatientSurgeryByAssessmentMade,
  onUpdatePatientSurgeryByNoPresentAssessment,
  setSelectedPatientSurgery,
  resetSelectedPatientSurgery,
  updateSelectedPatientSurgery,
} = calendarSlice.actions;
